import { render, staticRenderFns } from "./IconMessageSquare.vue?vue&type=template&id=3d707e42"
import script from "./IconMessageSquare.vue?vue&type=script&lang=js"
export * from "./IconMessageSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports